import { Component, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

import { AppService } from '@app/app.service';
import { AuthService } from '@app/auth/auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-delete',
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatTooltipModule
],
  standalone: true,
  templateUrl: './user-delete.component.html',
  styleUrl: './user-delete.component.scss'
})
export class UserDeleteComponent {

  deleteForm!: FormGroup;

  hide = signal(true);

  constructor(
    private fb: FormBuilder, 
    private appService: AppService,
    private authService: AuthService,
    private router: Router,
  ) {

    if(!environment.allowDeleteAccount) {
      this.router.navigate(['/account']);
      return;
    }

    this.deleteForm = this.fb.group({
      password: ['', [Validators.required]],
    });

  }

  deleteAccount() {
    if (this.deleteForm.invalid) {
      this.appService.showSnackBar('Please fill in all required fields', 'error');
      return;
    }
    
    this.appService.confirm('Are you sure you want to delete your account?').subscribe(result => {
      if (result) {
        this.authService.deleteAccount(this.deleteForm.value).subscribe({
          next: (response) => {
            this.appService.showSnackBar(response.message, 'success');
            this.authService.logout();
          },
          error: (error) => {
            this.appService.showSnackBar(error.error.message, 'error');
          }
        });
      }
    });
  }

  goBack() {
    this.router.navigate(['/account']);
  }

}
